import React, { useEffect, useState } from 'react'
import { Button, Form, Nav } from 'react-bootstrap'
import { FaRegSquarePlus } from "react-icons/fa6";
import * as yup from 'yup';
import { useFormik } from 'formik';
import toast from 'react-hot-toast'
import moment from 'moment';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { Box, Paper, Tooltip } from "@mui/material";
import DataTable from "react-data-table-component";
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import { getSubCategoryListing } from '../../api/context/subcategory';
import Loader from '../../components/loader/loader';
import { checkUserPermissions } from '../../helpers/permission';
import { useNavigate } from 'react-router-dom';
import { deleteManufacture, getAllManufactures } from '../../api/context/manufacturer';
import { IoSearchOutline } from 'react-icons/io5';
import { alignPropType } from 'react-bootstrap/esm/types';
import { FiEdit, FiRefreshCcw, FiRefreshCw, FiTrash2 } from 'react-icons/fi';

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            display: "flex",
            justifyContent: "center",
            fontWeight: '600',
            fontSize: '14px',
            padding: '16px 8px',
            backgroundColor: '#f9f9f9ff',
        },
    },
    cells: {
        style: {
            display: "flex",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },
};

const Manufacturer = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [update, setUpdate] = useState(false)
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [initial, setInitial] = useState(false)
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [sortBy, setSortBy] = useState('createdAt');
    const [sortDirection, setSortDirection] = useState('DESC');
    const [activeTab, setActiveTab] = useState('verified');
    const [isInitialRender, setIsInitialRender] = useState(true);

    const toggleModal = () => {
        setModal(!modal);
    };

    const columns = [
        {
            name: "S.No.",
            selector: (row, index) => ((page * limit) - limit) + (index + 1),
            width: '80px',
            center: true,
            style: {
                textAlign: 'center',
            },
        },
        {
            id: 'storeName',
            name: 'Store',
            selector: (row) => row?.storeName,
            cell: (row) => {
                const platform = row?.externalPlatform?.toLowerCase();

                // Platform initials and colors
                const platformData = {
                    'woocommerce': { initial: 'W', color: '#96588a' },
                    'shopify': { initial: 'S', color: '#5e8e3e' },
                    'magento': { initial: 'M', color: '#f46f25' },
                };

                const platformInfo = platformData[platform];

                return (
                    <div
                        className="d-flex align-items-center"
                        style={{
                            width: '100%',
                            cursor: 'pointer',
                            padding: '6px 8px',

                            gap: '8px',
                            minWidth: 0, // Important for truncation in flex children
                        }}
                        
                    >
                        {platformInfo && (
                            <div style={{
                                flexShrink: 0, // Prevent the icon from shrinking
                                width: '20px',
                                height: '20px',
                                borderRadius: '4px',

                                color: platformInfo.color,
                                border: `1px solid ${platformInfo.color}`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}>
                                {platformInfo.initial}
                            </div>
                        )}
                        <Tooltip title={row?.storeName} disableInteractive placement='top'>
                            <div style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textDecoration: 'underline',
                                textUnderlineOffset: '2px',
                                textDecorationThickness: '1px',
                                textDecorationColor: '#a94b4bff',
                                minWidth: 0, // Important for truncation in flex children
                            }}
                                 onClick={() => navigate('/edit-vendors/' + row.id)}
                            >
                                {row?.storeName}
                            </div>
                        </Tooltip>
                    </div>
                );
            },
            sortable: true,
            width: '150px',
        },
        {
            id: 'ownerName',
            name: 'Owner',
            selector: (row) => row?.ownerName,
            cell: (row) => (
                <div
                    className="text-center text-truncate"
                    style={{
                        width: '100%',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => navigate('/edit-vendors/' + row.id)}
                >
                    <Tooltip title={row?.ownerName} disableInteractive placement='top'>
                        <div>{row?.ownerName}</div>
                    </Tooltip>
                </div>
            ),
            sortable: true,
            width: '150px',
            center: true,
        },
        {
            id: 'address',
            name: 'Address',
            selector: (row) => row?.address,
            cell: (row) => (
                <div
                    className="text-center text-truncate"
                    style={{
                        maxWidth: '200px',
                        margin: '0 auto',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => navigate('/edit-vendors/' + row.id)}
                >
                    <Tooltip title={row?.address} disableInteractive placement="top">
                        <div>{row?.address}</div>
                    </Tooltip>
                </div>
            ),
            sortable: true,
            width: '220px',
            center: true,
        },
        {
            id: 'phoneNumber',
            name: ' Contact No',
            selector: (row) => row?.phoneNumber,
            cell: (row) => (
                <div
                    className="text-center text-truncate"
                    style={{
                        width: '100%',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => navigate('/edit-vendors/' + row.id)}
                >
                    <Tooltip title={row?.phoneNumber} disableInteractive placement='top'>
                        <div>{row?.phoneNumber}</div>
                    </Tooltip>
                </div>
            ),
            sortable: true,
            width: '170px',
            center: true,
        },
        {
            name: "ACTION",
            cell: (row) => (
                <div
                    className="d-flex justify-content-center"
                    onClick={(e) => e.stopPropagation()} // Prevent row click when clicking actions
                >
                    <div className='d-flex flex-row gap-3' role='button'>
                        <Tooltip title="Edit" disableInteractive placement="top">
                            <div
                                className="edit_icon_bg"
                                onClick={() => navigate('/edit-vendors/' + row.id)}
                            >
                                <FiEdit className="edit_icon text-white fs-5" />
                            </div>
                        </Tooltip>
                        <Tooltip title="Sync" disableInteractive placement="top">
                            <div
                                className="edit_icon_bg"
                                onClick={() => navigate('/sync-inventory/' + row.id)}
                            >
                                <FiRefreshCw className="edit_icon text-white fs-5" />
                            </div>
                        </Tooltip>
                        <Tooltip title="Delete" disableInteractive placement="top">
                            <div
                                className="delete_icon_bg"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleConfirm(row?.id);
                                }}
                            >
                                <FiTrash2 className="delete_icon text-black fs-5" />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            ),
            width: '200px',
            center: true,
            ignoreRowClick: true, // Prevent row click for this column
        },
    ];




    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    }

    const deleteManufactures = (id) => {
        deleteManufacture(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
                setModal(!modal);
                toast.success("Vendor deleted successfully")
            } else {
                toast.error(response?.data?.message);
            }
        });
    }

    const getManufactureData = async () => {
        setLoading(true);
        getAllManufactures({
            page: page,
            pageSize: limit,
            search: search,
            sortBy: sortBy,
            sortDirection: sortDirection,
            isVerified: activeTab === 'verified' ? true : false,
        })((response) => {
            if (response?.statusCode == 200) {
                setData(response?.data?.manufacturers);
                setTotalRows(response?.data?.totalCount);
                setLoading(false);
            } else {
                setData([]);
                setLoading(false);
            }
        });
    }

    useEffect(() => {
        getManufactureData();
        setIsInitialRender(false);
    }, [update, page, limit, sortBy, sortDirection]);

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) setUpdate(!update);
            else setInitial(true);
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    const handleSort = (column, sortDirection) => {
        setSortBy(column.id);
        setSortDirection(sortDirection);
        setUpdate(!update);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    useEffect(() => {
        if (!isInitialRender) {
            setPage(1); // Reset to first page when changing tabs
            getManufactureData();
        }
    }, [activeTab]);

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-stretch mb-3">
                            <div className="d-flex align-items-center">
                                <h3 className="mb-0  fw-bolder">Vendors</h3>
                            </div>

                            
                                <div className="d-flex align-items-center">
                                    <div className="form_wrapper me-3">
                                        <Form className="app-search d-none d-md-block p-0 m-0">
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search for vendors..."
                                                    // value={search}
                                                    onChange={(e) => setSearch(e.target.value.trim())}
                                                    style={{
                                                        width: "350px",
                                                        height: "46px",
                                                        padding: "14px 20px"
                                                    }}
                                                />
                                                <IoSearchOutline className='search_icon' />
                                            </div>
                                        </Form>
                                    </div>

                                    {checkUserPermissions('manage_manufacturer') && (
                                        <Button
                                            className='request_btn'
                                            onClick={() => navigate('/create-vendors')}
                                        >
                                            <FaRegSquarePlus className='icon' />Add New Vendor
                                        </Button>
                                    )}
                                </div>
                       
                        </div>

                    </div>


                    {/* Add the tabs navigation */}
                    <div className="mb-2">
                        <Nav
                            variant="tabs"
                            defaultActiveKey="verified"
                            activeKey={activeTab}
                            onSelect={setActiveTab}
                            className="mb-2 custom-order-tabs"
                        >
                            <Nav.Item>
                                <Nav.Link
                                    eventKey="verified"
                                    className={`fs-7 fw-semibold ${activeTab === 'verified' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                    style={{
                                        padding: '12px 24px',

                                        backgroundColor: activeTab === 'verified' ? '#f8f9fa' : 'transparent',
                                        transition: 'all 0.3s ease',
                                        color: activeTab === 'verified' ? '#000' : '#6c757d'
                                    }}
                                >
                                    Verified
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link
                                    eventKey="notVerified"
                                    className={`fs-7 fw-semibold ${activeTab === 'notVerified' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                    style={{
                                        padding: '12px 24px',

                                        backgroundColor: activeTab === 'notVerified' ? '#f8f9fa' : 'transparent',
                                        transition: 'all 0.3s ease',
                                        color: activeTab === 'notVerified' ? '#000' : '#6c757d'
                                    }}
                                >
                                    Not verified
                                </Nav.Link>
                            </Nav.Item>

                        </Nav>
                    </div>


                    <CustomisedModal
                        isOpen={modal}
                        customClass={"policy_modal"}
                        toggle={toggleModal}
                    >
                        <h5>Are you sure you want to remove this item?</h5>
                        <div className="policy_Agree">
                            <Button
                                onClick={() => setModal(!modal)}
                                size="lg"
                                className='btn_cancel'
                            >
                                Cancel
                            </Button>
                            <Button
                                size="lg"
                                className='btn'
                                onClick={() => deleteManufactures(deletingId)}
                            >
                                Delete
                            </Button>
                        </div>
                    </CustomisedModal>

                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square className='shadow-none border border-blue-grey-200'>
                            <div>
                                <DataTable
                                    columns={columns}
                                    pointerOnHover // Adds cursor pointer on hover
                                    highlightOnHover // Adds hover effect
                                    data={data}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                    paginationPerPage={limit}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    onSort={handleSort}
                                    sortServer
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                />
                            </div>
                        </Paper>
                    </Box>
                </div>
            </div>
        </>
    )
}

export default Manufacturer;